import { Component, Input } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { LinkedItemsListManageDialogComponent } from '../../../../shared/components/linked-items-list-manage-dialog/linked-items-list-manage-dialog.component';
import { UIDialogService } from '../../../../shared/services/ui-dialog.service';
import { DataTableUtils } from '../../../../shared/utils/data-table.utils';
import { AuthService } from '../../../security/service/auth.service';
import { PartsUIMessages } from '../../model/parts-ui.message';
import { PartsService } from '../../service/parts.service';

@Component({
  selector: 'app-parts-line-of-service',
  templateUrl:
    './console/app-js/modules/parts/components/parts-line-of-service/parts-line-of-service.component.html'
})
export class PartsLineOfServiceComponent extends APIOperableComponent {
  @Input('partId') partId: string;
  public canManageParts = false;
  private linesOfService = [];
  public linesOfServiceFiltered = [];
  private linesOfServiceInactive = [];
  public filterValue = '';
  public loading = false;

  constructor(
    public toastr: ToastrService,
    public progressService: NgProgress,
    public authService: AuthService,
    private partsService: PartsService,
    private dialogService: UIDialogService
  ) {
    super(progressService, toastr, authService);
  }

  ngOnInit() {
    // VL-2482: Admin Portal part management actions are disabled.
    this.canManageParts = false;
    this.getLinesOfService(this.partId);
  }

  private getLinesOfService(partId: string) {
    this.loading = true;
    this.partsService.getPartLinesOfService(partId, true).subscribe(
      res => {
        this.linesOfServiceInactive = res.filter(line => !line.isActive);
        this.linesOfService = res.filter(line => line.isActive);
        this.linesOfServiceFiltered = this.linesOfService;
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  public onClearFilter() {
    this.filterValue = '';
    this.onFilterData();
  }

  private onFilterData(): void {
    this.linesOfServiceFiltered = DataTableUtils.filterDataByProperty(
      this.linesOfServiceFiltered,
      this.linesOfService,
      this.filterValue,
      'name'
    );
  }

  public onManage() {
    if (!this.canManageParts) {
      return;
    }
    this.dialogService
      .open(LinkedItemsListManageDialogComponent, [
        {
          provide: Array,
          useValue: this.linesOfService
        },
        {
          provide: Function,
          useValue: this.partsService.getLinesOfService
        },
        {
          provide: 'allItems',
          useValue: null
        },
        {
          provide: 'title',
          useValue: 'Line of Services'
        },
        {
          provide: 'property',
          useValue: 'name'
        },
        {
          provide: 'idField',
          useValue: 'id'
        }
      ])
      .then(results => {
        this.progressRef.start();
        // contains all added lines of service
        const newLinesOfService = results.filter(
          lineOfService =>
            !this.linesOfService.find(l => lineOfService.id === l.id)
        );
        // contains lines of service that were removed - call PUT isActive = false
        const deletedLinesOfService = this.linesOfService.filter(
          lineOfService => !results.find(l => lineOfService.id === l.id)
        );
        // contains added lines of service with previous relationship = call PUT isActive = true
        const newLinesOfServicePut = newLinesOfService.filter(lineOfService =>
          this.linesOfServiceInactive.find(l => lineOfService.id === l.id)
        );
        // contains added lines of service without previous relationship = call POST
        const newLinesOfServicePost = newLinesOfService.filter(
          lineOfService =>
            !this.linesOfServiceInactive.find(l => lineOfService.id === l.id)
        );
        this.partsService
          .updatePartLinesOfService(
            newLinesOfServicePut,
            newLinesOfServicePost,
            deletedLinesOfService,
            this.partId
          )
          .subscribe(
            (res: any) => {
              if (res) {
                this.toastr.success(
                  PartsUIMessages.UPDATE_LINES_OF_SERVICE_SUCCESS
                );
                this.getLinesOfService(this.partId);
              } else {
                this.toastr.error(
                  PartsUIMessages.UPDATE_LINES_OF_SERVICE_ERROR
                );
              }
            },
            error => {
              this.toastr.error(error.errorMessage);
            },
            () => {
              this.progressRef.complete();
            }
          );
        this.progressRef.complete();
      })
      .catch(error => {
        if (error) {
          console.log(error);
        }
        // on popup Cancel button, do nothing by the moment.
      });
  }
}
